import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http: HttpClient) { }

  saveProductService(id: any, data: any) {
    const { company, ...payload } = data
    if (id) {
      return this.http.put(urls.API_URL + urls.SERVICES + `/${company}/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.SERVICES + '/' + company, payload)
      .pipe(catchError(errorHandl));
  }

  getProductServices(queryParams?:any) {
     const params = new HttpParams({ fromObject: queryParams});
    return this.http.get(urls.API_URL + urls.SERVICES, {params})
      .pipe(catchError(errorHandl));
  }

  getProductServiceById(id: any) {
    return this.http.get(urls.API_URL + urls.SERVICES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getAccount(id:any, queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.ACCOUNT + `/${id}`, { params })
      .pipe(catchError(errorHandl));
  }


   syncProductService(compamyId:any, serviceId:any, queryParams: any = {}) {
      const params = new HttpParams({ fromObject: queryParams || {} });
      return this.http.get(urls.API_URL + urls.SERVICES + `/${compamyId}/${urls.SYNC}/${serviceId}`, { params })
        .pipe(catchError(errorHandl));
  }
}
